import { replaceMaterialSnippets } from '#imports';

export const setupDefaultTextMaterial = (shader) => {
    replaceMaterialSnippets({
        material: shader,
        vertex: [
            {
                snippet: 'attribute vec3 aTroikaGlyphColor;',
                newSnippet: /* glsl */ `
                        attribute vec3 aOffset;
                        attribute float aAlpha;
                        varying float vAlpha;
                        varying vec3 vTransformed;
                    `,
            },
            {
                snippet: 'vec3 transformed = vec3( troika_position_1 );',
                newSnippet: /* glsl */ `
                        transformed += aOffset;
                        vAlpha = aAlpha;
                        vTransformed = transformed;
                    `,
            },
        ],
        fragment: [
            {
                snippet: 'varying vec3 vTroikaGlyphColor;',
                newSnippet: /* glsl */ `
                        varying float vAlpha;
                        varying vec3 vTransformed;
                    `,
            },
            {
                snippet: 'gl_FragColor.a *= edgeAlpha;',
                newSnippet: /* glsl */ `
                        #ifdef USE_MASK
                            float grd = (vTransformed.y + vTroikaGlyphDimensions.y) / vTroikaGlyphDimensions.y;
                            float mask = smoothstep(-0.75, 0., grd );
                            gl_FragColor.a *= mask;
                        #endif
                        gl_FragColor.a *= vAlpha;
                    `,
            },
        ],
    });
};
